import React from 'react';
import './ReceiptTotalTitle.scss';
import { TranslationUtils, CurrencyUtils } from '../../utils';
import { ConvertedCurrencyNotice } from './ConvertedCurrencyNotice';
import { PaymentAmount } from 'guest-data-types-ts-lib';

interface ReceiptTitleProps {
    summary: PaymentAmount;
    convertedSummary?: PaymentAmount;
    locale: string;
    withoutBackground?: boolean;
    text?: string;
}

export const ReceiptTotalTitle: React.FC<ReceiptTitleProps> = (props) => {
    const { summary, convertedSummary, locale, withoutBackground, text } = props;
    const totalValue = CurrencyUtils.formatCurrency(summary.total, summary.currency, locale);
    const isConverted = convertedSummary && summary.currency !== convertedSummary.currency;
    const totalText = text ? text : TranslationUtils.get('total_in', { currency: summary.currency });
    return (
        <React.Fragment>
            {isConverted && convertedSummary && (
                <ConvertedCurrencyNotice
                    convertedCurrency={convertedSummary.currency}
                    convertedTotal={convertedSummary.total}
                    originalCurrency={summary.currency}
                    originalTotal={summary.total}
                    locale={locale}
                />
            )}
            {!isConverted && (
                <div
                    data-testid={'add-pet-count-preview'}
                    className={`receipt-total-title ${withoutBackground ? 'without-background' : ''}`}
                >
                    <div>
                        <span className={'body-bold'} tabIndex={0} aria-label={`${totalText} ${totalValue}`}>
                            {totalText}
                        </span>
                    </div>
                    <div className="receipt-total-title-value">
                        <span className={'body-bold'}>{totalValue}</span>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};
